module.exports = __webpack_public_path__ + "static/media/441765430_500921602258130_5887006327870398326_n.844480f4.jpg";